import { TArmor } from "../../mechanics/items/Armor"
import { TItem } from "../../mechanics/items/Item"
import { TWeapon } from "../../mechanics/items/Weapon"
import "./ToolTip.scss"

export type TPosition = "top" | "bottom" | "left" | "right" | 'top-inventory-items'

export interface IToolTipObject {
    type: TItem | TArmor | TWeapon
    name: string
    restoreValue?: number
    armorValue?: number
    weaponDamage?: number
    cost?: number
}

interface ITiilTipProps {
    text: string
    position: TPosition
    toolTipObjectContent?: IToolTipObject
}

export default function ToolTip({ text, position, toolTipObjectContent }: ITiilTipProps) {

    const objContent = <>
        <p>Type: {toolTipObjectContent?.type}</p>
        <p>Name: {toolTipObjectContent?.name}</p>
        {toolTipObjectContent?.restoreValue ?
            <p>Restore value: {toolTipObjectContent?.restoreValue}</p>
            :
            null
        }
        {toolTipObjectContent?.armorValue ?
            <p>Armor value: {toolTipObjectContent?.armorValue}</p>
            :
            null
        }
        {toolTipObjectContent?.weaponDamage ?
            <p>Weapon damage: {toolTipObjectContent?.weaponDamage}</p>
            :
            null
        }
        {toolTipObjectContent?.cost ?
            <p>Cost: {toolTipObjectContent?.cost}</p>
            :
            <p>Cost: 0</p>
        }
    </>

    return (
        <div className={`tool-tip tip-stats tool-tip-${position}`}>
            {toolTipObjectContent ? objContent : text}
        </div>
    )
}
